import { AGENT_NAMES } from '../../constants/agentNames.ts'

export type PostMediaConfirmRoute = 'post' | 'producto' | 'servicio'

export function isProjectAutofillPdfContext(
  activeAgent: string,
  collectedIntent: string | undefined
): boolean {
  return (
    activeAgent === AGENT_NAMES.projectAutofillAgent || collectedIntent === 'project_autofill'
  )
}

export function isPostSpecialistMediaContext(
  activeAgent: string,
  collectedIntent: string | undefined
): boolean {
  if (activeAgent === AGENT_NAMES.postAgent) return true
  return collectedIntent === 'create_post' || collectedIntent === 'create_portfolio_item'
}

export function isGeneralAgent(activeAgent: string): boolean {
  return activeAgent === AGENT_NAMES.general
}
